import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';

export function buildJourneyEnteredFilterString ({ filterIndex }) {
    return `!isNull(addedAt${filterIndex})`;
}

export function buildJourneyNotEnteredFilterString ({ filterIndex }) {
    return `isNull(addedAt${filterIndex})`;
}

export function buildJourneyTimeBeforeFilterString ({ filterIndex, first }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `addedAt${filterIndex}<=date("${date}")`;
}

export function buildJourneyTimeSinceFilterString ({ filterIndex, first }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `addedAt${filterIndex}>=date("${date}")`;
}

export function buildJourneyTimeBetweenFilterString ({ filterIndex, first, last }) {
    const formattedFirst = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);
    const formattedLast = moment(last, { ignoreTimeZone: true })
        .add(1, 'days')
        .format(DATE_FORMAT.iso);

    return `(addedAt${filterIndex}>=date("${formattedFirst}")&&addedAt${filterIndex}<date("${formattedLast}"))`;
}

export function buildJourneyTimeWithinLastFilterString ({ filterIndex, count, granularity }) {
    return `addedAt${filterIndex}>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}")`;
}

export function buildJourneyTimeNotWithinLastFilterString ({ filterIndex, count, granularity }) {
    return `(addedAt${filterIndex}>=now()||addedAt${filterIndex}<=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

export function parseJourneyFilterPipeline ({ fact, time, filterIndex, ...params }) {
    let filterString;
    const filterParams = { filterIndex, ...params };

    switch (fact) {
        case 'entered':
            filterString = buildJourneyEnteredFilterString(filterParams);
            switch (time) {
                case '<=':
                    filterString += `&&${buildJourneyTimeBeforeFilterString(filterParams)}`;
                    break;
                case '>=':
                    filterString += `&&${buildJourneyTimeSinceFilterString(filterParams)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildJourneyTimeWithinLastFilterString(filterParams)}`;
                    break;
                case '!withinLast':
                    filterString += `&&${buildJourneyTimeNotWithinLastFilterString(filterParams)}`;
                    break;
                case 'between':
                    filterString += `&&${buildJourneyTimeBetweenFilterString(filterParams)}`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
        case 'notentered':
            filterString = buildJourneyNotEnteredFilterString(filterParams);
            switch (time) {
                case '<=':
                    filterString += `||!(${buildJourneyTimeBeforeFilterString(filterParams)})`;
                    break;
                case '>=':
                    filterString += `||!(${buildJourneyTimeSinceFilterString(filterParams)})`;
                    break;
                case 'withinLast':
                    filterString += `||!(${buildJourneyTimeWithinLastFilterString(filterParams)})`;
                    break;
                case '!withinLast':
                    filterString += `||!(${buildJourneyTimeNotWithinLastFilterString(filterParams)})`;
                    break;
                case 'between':
                    filterString += `||!(${buildJourneyTimeBetweenFilterString(filterParams)})`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
    }

    return { filter: filterString };
}
